import { Injectable } from '@angular/core';
import { NotificationLevel, TranslationWithParams } from '@os-components';
import { BehaviorSubject, Observable } from 'rxjs';

export type Notification = {
    level: NotificationLevel;
    headline?: string | TranslationWithParams;
    content: string | TranslationWithParams;
    links?: Array<{
        text: string | TranslationWithParams | Observable<string>;
        href: string;
    }>;
};

type PartialNotification = Partial<Notification> & { content: string | TranslationWithParams };

@Injectable({
    providedIn: 'root',
})
export class NotificationService {
    private notifications = new BehaviorSubject<Notification[]>([]);

    public getNotifications() {
        return this.notifications.asObservable();
    }

    public add(notification: Notification): void {
        this.notifications.next([...this.notifications.value, notification]);
    }

    public addInfo(info: string | PartialNotification) {
        if (typeof info === 'string') {
            info = { content: info };
        }

        this.add({ ...info, level: NotificationLevel.INFO });
    }

    public addWarning(warning: string | PartialNotification) {
        if (typeof warning === 'string') {
            warning = { content: warning };
        }

        this.add({ ...warning, level: NotificationLevel.WARNING });
    }

    public addError(error: string | PartialNotification) {
        if (typeof error === 'string') {
            error = { content: error };
        }

        this.add({ ...error, level: NotificationLevel.ERROR });
    }

    public removeNotification(index: number) {
        const current = this.notifications.value;
        this.notifications.next([...current.slice(0, index), ...current.slice(index + 1)]);
    }

    public removeAllNotifications() {
        this.notifications.next([]);
    }
}
